import axios from "../../config/axios"
function create(data) {
    return axios().post("/fleet/brands", data)    
}

function get(id) {
    return axios().get(`/fleet/brands/${id}`)
}

function update(id, data) {
    return axios().put(`/fleet/brands/${id}`, data)
}

function remove(id) {
    return axios().delete(`/fleet/brands/${id}`)
}

function list() {
    return axios().get(`/fleet/brands`)
}

function listModels(id) {
    return axios().get(`/fleet/brands/${id}/models`)
}

export default {
    create,
    get,
    update,
    remove,
    list,
    listModels
}